import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './HomeProduct.css'
import { ButtonView } from '../components/Buttons/Buttons'
import { Link } from 'react-router-dom';
const HomeProductsOne= () => {
    const navigate = useNavigate();
    const handlenavigate = () => {
        navigate('/');
    }
  return (
    <>
    <div className='product_background bg-overlay padding z'>
        <Container className='z'>
            <Row>
                <Col lg="12" xs="12" md="12">
                    <div className='text-center z text-white'>
                        <h2 className='bold'> Our Products</h2>
                        <p className='regular'>With over 200 varieties of crackers developed and marketed every year, we are among the most sought brands in the Sivakasi region and around the country. Our products are known for their safety and we take great efforts to ensure that all our orders are delivered in a standard time frame with an economical pricing.
                        </p>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/singlesound.webp')} className='img-fluid w-75' alt='single sound'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">💥 High Sound</span>
                            <div className="home-product-title">Single Sound Crackers</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/garland.webp')} className='img-fluid w-75' alt='garland crackers'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">🎉 Festive Garland</span>
                            <div className="home-product-title">Garland Crackers (Wala)</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/sparklers.webp')} className='img-fluid w-75' alt='sparklers'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">✨ Kids Special</span>
                            <div className="home-product-title">Color Sparklers</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/rockets.webp')} className='img-fluid w-75' alt='rockets'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">🚀 Sky Thrill</span>
                            <div className="home-product-title">Whistling Rockets</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/flowerpots.webp')} className='img-fluid w-75' alt='flower pots'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">🌺 Traditional</span>
                            <div className="home-product-title">Flower Pots (Kothu)</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/chakkar.webp')} className='img-fluid w-75' alt='ground chakkars'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">🌀 Spinning Fire</span>
                            <div className="home-product-title">Ground Chakkars</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/fancyfountain.webp')} className='img-fluid w-75' alt='fancy fountains'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">⛲ Dazzling Lights</span>
                            <div className="home-product-title">Fancy Fountains</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col lg='3' md="6" xs='12' className='my-3'>
                    <div className='home-product-box' onClick={handlenavigate} style={{ cursor: 'pointer' }}>
                        <div className='hm-product text-center'>
                            <img src={require('../assets/images/homeproducts/homeproductsone/skyshots.png')} className='img-fluid w-75' alt='sky shots'/>
                        </div>
                        <div className="text-center p-3">
                            <span className="home-product-badge">🌌 Night Special</span>
                            <div className="home-product-title">Aerial Sky Shots</div>
                            <div className="btn-card-explore">View Prices →</div>
                        </div>
                    </div>
                </Col>
                <Col xs="12">
                    <div className='z text-center py-4'>
                        <ButtonView label={<>🔥 View Full 200+ Crackers Price List</>} className="shop-now" onClick={handlenavigate}/>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
       
    </>
  )
}

const HomeProductsTwo = () => {
    const navigate = useNavigate();
    const handlenavigate = () => {
        navigate('/');
    }
  return (
    <>
    <div className='product_background bg-overlay padding'>
        <Container className='z'>
            <Row>
            <Col xs='12' className='py-3'>
            <h2 className='text-white text-center bold py-2'> Our Products</h2>
                <div className='text-center text-white regular'>With over 200 varieties of crackers developed and marketed every year, we are among the most sought brands in the Sivakasi region and around the country. Our products are known for their safety and we take great efforts to ensure that all our orders are delivered in a standard time frame with an economical pricing.</div>
            </Col>
                <Col lg='2' md="3" xs='6' className='my-3'>
                    <div className='home-product-box-two'>
                        <img src={require('../assets/images/homeproducts/homeproductstwo/bombs.jpg')} className='img-fluid brd' alt='single sound'/>
                    </div>
                    <div className='py-2 text-center'>
                        <h5 className='bold text-white'> Ground Chakkars</h5>
                    </div>
                </Col>
                <Col lg='2' md="3" xs='6' className='my-3'>
                    <div className='home-product-box-two'>
                        <img src={require('../assets/images/homeproducts/homeproductstwo/sparklers.jpg')} className='img-fluid brd' alt='single sound'/>
                    </div>
                    <div className='py-2 text-center'>
                        <h5 className='bold text-white'> Sparklers</h5>
                    </div>
                </Col>
                <Col lg='2' md="3" xs='6' className='my-3'>
                    <div className='home-product-box-two'>
                        <img src={require('../assets/images/homeproducts/homeproductstwo/colourmatches.jpg')} className='img-fluid brd' alt='single sound'/>
                    </div>
                    <div className='py-2 text-center'>
                        <h5 className='bold text-white'> Garlands</h5>
                    </div>
                </Col>
                <Col lg='2' md="3" xs='6' className='my-3'>
                    <div className='home-product-box-two'>
                        <img src={require('../assets/images/homeproducts/homeproductstwo/flowerpots.jpg')} className='img-fluid brd' alt='single sound'/>
                    </div>
                    <div className='py-2 text-center'>
                        <h5 className='bold text-white'> Sound Crackers</h5>
                    </div>
                </Col>
                <Col lg='2' md="3" xs='6' className='my-3'>
                    <div className='home-product-box-two'>
                        <img src={require('../assets/images/homeproducts/homeproductstwo/fountain.jpg')} className='img-fluid brd' alt='single sound'/>
                    </div>
                    <div className='py-2 text-center'>
                        <h5 className='bold text-white'> Rockets</h5>
                    </div>
                </Col>
                <Col lg='2' md="3" xs='6' className='my-3'>
                    <div className='home-product-box-two'>
                        <img src={require('../assets/images/homeproducts/homeproductstwo/giftbox.jpg')} className='img-fluid brd' alt='single sound'/>
                    </div>
                    <div className='py-2 text-center'>
                        <h5 className='bold text-white'> Flower Pots</h5>
                    </div>
                </Col>
                <Col lg='12'>
                    <div className='text-center'>
                        <ButtonView label={<>Shop Now</>} className="shop-now" onClick={handlenavigate}/>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
      
    </>
  )
}
/* eslint-disable no-dupe-keys */

const HomeProductThree = () => {
    var settings = {
      dots: false,
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      speed: 1700,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }
      ]
    };
  
    return (
      <>
        <div>
          <Container>
            <Row>
              <Col xs={12}>
                <div className="text-center my-5">
                  <h3>OUR PRODUCTS</h3>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Slider {...settings} className='padding'>
          <div className="slider-image">
            <Link to="/">  {/* Add Link to wrap the image */}
              <img src={require('../assets/images/homeproducts/homeproducts_three/Chakkar.webp')} className='img-fluid brd' alt='Chakkar' />
            </Link>
          </div>
          <div className="slider-image">
            <Link to="/">
              <img src={require('../assets/images/homeproducts/homeproducts_three/Flower-pots.webp')} className='img-fluid brd' alt='Flower Pots' />
            </Link>
          </div>
          <div className="slider-image">
            <Link to="/">
              <img src={require('../assets/images/homeproducts/homeproducts_three/Rocket.webp')} className='img-fluid brd' alt='Rocket' />
            </Link>
          </div>
          <div className="slider-image">
            <Link to="/">
              <img src={require('../assets/images/homeproducts/homeproducts_three/Sound-crackers.webp')} className='img-fluid brd' alt='Sound Crackers' />
            </Link>
          </div>
          <div className="slider-image">
            <Link to="/">
              <img src={require('../assets/images/homeproducts/homeproducts_three/garland.webp')} className='img-fluid brd' alt='Garland' />
            </Link>
          </div>
          <div className="slider-image">
            <Link to="/">
              <img src={require('../assets/images/homeproducts/homeproducts_three/sparkler.webp')} className='img-fluid brd' alt='Sparkler' />
            </Link>
          </div>
        </Slider>
      </>
    );
  }

export {HomeProductsOne,HomeProductsTwo,HomeProductThree}